<template lang="pug">
  .fe-list(v-infinite-scroll="onLoadMore" infinite-scroll-disabled="disabledLoadingMore" infinite-scroll-distance="50")
    v-data-table(v-show="false" :headers="headers")
    app-table(
      v-model="activeItems"
      :headers="headers"
      :list="list"
      :loading="loading"
      item-key="id"
      multi-sort=false
      :server-items-length="list.length"
      :show-select="true"
      :single-select="false"
      :mobile-breakpoint='NaN'
      :sort-by.sync="sortModel.by"
      :sort-desc.sync="sortModel.desc"
      @update:sort-desc="updateSorting"
      hide-default-header
      hide-default-footer
      class="app-table-new v-data-table theme--light"
    )
      template(v-slot:top)
        actions(
          :loading="loading"
          :disabled="!hasActiveItems"
          :activeItems="activeItems"
          @needToUpdate="updateItems"
        )
      template(v-slot:item="{item, select, isSelected, index}")
        item(
          :item="item"
          :isSelected="isSelected"
          :select="select"
          :index="index"
          :key="item.id"
          :activeItems="activeItems"
          :pagination="pagination"
          :primaryPagination="primaryPagination"
          @change:status="$emit('change:status', $event)"
          @needToUpdate="$emit('needToUpdate')"
        )
</template>

<script>
import InfinityScroll from '@/components/global/infinityScroll.vue'
import SortModel from '../core/feedback-sortModel'

export default {
  name: 'FeedbackList',

  props: {
    list: Array,
    headers: Array,
    loading: Boolean,
    pagination: Object,
    primaryPagination: Object
  },

  data: () => ({
    activeItems: [],
    sortModel: null
  }),

  computed: {
    disabledLoadingMore() {
      if (!this.pagination) return true
      if (this.loading) return true
      if (!this.pagination.next) return true
      return false
    },

    hasActiveItems() {
      return !!(this.activeItems && this.activeItems.length)
    },
  },

  created() {
    this.initSortModel()
  },

  methods: {
    initSortModel() {
      this.sortModel = new SortModel(this.$route.query)
    },

    onLoadMore() {
      if (!this.pagination) return
      this.$emit('loadMore')
    },

    updateItems() {
      this.reset()
      this.update()
    },

    reset() {
      this.activeItems = []
    },

    update() {
      this.$emit('needToUpdate')
    },

    async updateSorting() {
      let data = this.sortModel.getApiData(this.$route.query)
      let ordering
      if (data.ordering.length) ordering = data.ordering
      this.$emit('change:sorting', ordering)
    }
  },

  components: {
    infinityScroll: InfinityScroll,
    appTable: () => import('@/components/global/GroupedTable.vue'),
    item: () => import('./FeedbackItem.vue'),
    actions: () => import('./FeedbackActions.vue')
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/tableNew';

.app-table-new .v-data-table tbody tr td:first-child {
  width: 32px;
  height: 32px;
}

.fe-list {
  min-height: 100vh;
}

.task-app-table {
  display: table;
  width: 100%;
}
</style>
